import { commonCarouselSettings, DEFAULT_PAGINATION } from 'src/lib/constants';
import { ApiRoutes, AppRoutes } from 'src/lib/routes';
import Link from 'next/link';
import { BsStarFill } from 'react-icons/bs';
import Slider from 'react-slick';
import { HiOutlineArrowNarrowLeft, HiOutlineArrowNarrowRight } from 'react-icons/hi';
import { useTranslations } from 'next-intl';
import GoogleReviewSvg from 'public/images/svg_icons/google_review.svg';
import TrustpilotReviewSvg from 'public/images/svg_icons/trustpilot_review.svg';
import reviewStyle from 'src/styles/modules/components/customer-review.module.scss';
import useQuery from 'src/hooks/useQuery';
import { Pagination } from 'src/types';

const FAQs = [
  {
    titleTranslationKey: 'review0001.title',
    bodyTranslationKey: 'review0001.body',
    name: 'Stella',
  },
  {
    titleTranslationKey: 'review0002.title',
    bodyTranslationKey: 'review0002.body',
    name: 'Zaya',
  },
  {
    titleTranslationKey: 'review0003.title',
    bodyTranslationKey: 'review0003.body',
    name: 'Sandra',
  },
  {
    titleTranslationKey: 'review001.title',
    bodyTranslationKey: 'review001.body',
    name: 'Ian',
  },
  {
    titleTranslationKey: 'review002.title',
    bodyTranslationKey: 'review002.body',
    name: 'Kallie',
  },
  {
    titleTranslationKey: 'review003.title',
    bodyTranslationKey: 'review003.body',
    name: 'Dara',
  },
  {
    titleTranslationKey: 'review01.title',
    bodyTranslationKey: 'review01.body',
    name: 'Viera',
  },
  {
    titleTranslationKey: 'review02.title',
    bodyTranslationKey: 'review02.body',
    name: 'Sherrie',
  },
  {
    titleTranslationKey: 'review1.title',
    bodyTranslationKey: 'review1.body',
    name: 'Michelle Chew',
  },
  {
    titleTranslationKey: 'review2.title',
    bodyTranslationKey: 'review2.body',
    name: 'Martin F',
  },
  {
    titleTranslationKey: 'review3.title',
    bodyTranslationKey: 'review3.body',
    name: 'Christina Lim',
  },
  {
    titleTranslationKey: 'review4.title',
    bodyTranslationKey: 'review4.body',
    name: 'Olivia Alim',
  },
  {
    titleTranslationKey: 'review5.title',
    bodyTranslationKey: 'review5.body',
    name: 'Lauren',
  },
  {
    titleTranslationKey: 'review6.title',
    bodyTranslationKey: 'review6.body',
    name: 'Matthew Fredrickson',
  },
  {
    titleTranslationKey: 'review7.title',
    bodyTranslationKey: 'review7.body',
    name: 'Ash B',
  },
  {
    titleTranslationKey: 'review8.title',
    bodyTranslationKey: 'review8.body',
    name: 'Peggy',
  },
  {
    titleTranslationKey: 'review9.title',
    bodyTranslationKey: 'review9.body',
    name: 'Sammy B',
  },
  {
    titleTranslationKey: 'review10.title',
    bodyTranslationKey: 'review10.body',
    name: 'Salihin Masnor',
  },
  {
    titleTranslationKey: 'review11.title',
    bodyTranslationKey: 'review11.body',
    name: 'Olivia Alim',
  },
  {
    titleTranslationKey: 'review12.title',
    bodyTranslationKey: 'review12.body',
    name: 'Kelly Pang',
  },
  {
    titleTranslationKey: 'review13.title',
    bodyTranslationKey: 'review13.body',
    name: 'Sophie Lenz',
  },
  {
    titleTranslationKey: 'review14.title',
    bodyTranslationKey: 'review14.body',
    name: 'Sara Martin Sanchez',
  },
  {
    titleTranslationKey: 'review15.title',
    bodyTranslationKey: 'review15.body',
    name: 'Anonymous (from Canada)',
  },
  {
    titleTranslationKey: 'review16.title',
    bodyTranslationKey: 'review16.body',
    name: 'Denise Lim',
  },
  {
    titleTranslationKey: 'review17.title',
    bodyTranslationKey: 'review17.body',
    name: 'Shefali Prasad',
  },
  {
    titleTranslationKey: 'review18.title',
    bodyTranslationKey: 'review18.body',
    name: 'Quint Simon',
  },
  {
    titleTranslationKey: 'review19.title',
    bodyTranslationKey: 'review19.body',
    name: 'Michelle Okonkwo',
  },
  {
    titleTranslationKey: 'review20.title',
    bodyTranslationKey: 'review20.body',
    name: 'hamizah ilham',
  },
  {
    titleTranslationKey: 'review21.title',
    bodyTranslationKey: 'review21.body',
    name: 'Charlotte Cole',
  },
  {
    titleTranslationKey: 'review22.title',
    bodyTranslationKey: 'review22.body',
    name: 'Jay',
  },
  {
    titleTranslationKey: 'review23.title',
    bodyTranslationKey: 'review23.body',
    name: 'Mike Ward',
  },
  {
    titleTranslationKey: 'review24.title',
    bodyTranslationKey: 'review24.body',
    name: 'Clarette Crame',
  },
] as { titleTranslationKey: string; bodyTranslationKey: string; name: string }[];

const StaticCustomerReviews: React.FC<{
  title?: string;
}> = ({ title }) => {
  const translation = useTranslations('components.StaticCustomerReviews');
  const { data, isLoading } = useQuery<{
    extra: {
      averageRating: number;
      rateExcellent: number;
      rateVeryGood: number;
      rateAverage: number;
      ratePoor: number;
      rateTerrible: number;
    };
    pagination: Pagination;
  }>(ApiRoutes.apiCustomerReviewsRoute({}, {}).toUrl());
  const { extra, pagination } = data || { extra: {}, pagination: DEFAULT_PAGINATION };

  return isLoading ? (
    <></>
  ) : (
    <div className="tw-bg-brand-navy tw-py-16 md:tw-py-24">
      <div className="container">
        <h2 className="tw-mb-0 tw-text-brand-green tw-font-styleSans tw-text-center tw-font-semibold tw-text-5xl md:tw-text-6xl md:tw-leading-none tw-leading-none tw-w-72 tw-px-1 md:tw-w-96 tw-mx-auto">
          {title ? title : translation('title')}
        </h2>

        <div className="tw-my-8">
          <div className="tw-text-center tw-text-white tw-flex tw-items-center tw-justify-center tw-mb-2">
            <div className="tw-text-sm tw-font-semibold">{extra.averageRating}</div>
            <div className="tw-px-4">
              <TrustpilotReviewSvg className="tw-align-top" />
            </div>
            <div>
              <GoogleReviewSvg className="tw-align-top" />
            </div>
          </div>

          <div className="tw-text-center">
            <Link legacyBehavior prefetch={false} href={AppRoutes.customerReviewsRoute().toPath()}>
              <a className="tw-text-sm tw-underline tw-cursor-pointer tw-text-grey">
                {translation('numberReviews', { number: pagination.totalCount })}
              </a>
            </Link>
          </div>
        </div>

        <Slider
          {...commonCarouselSettings}
          prevArrow={
            <div className="slick-prev">
              <HiOutlineArrowNarrowLeft
                size={24}
                strokeWidth={2}
                className="tw-text-white hover:tw-text-brand-green"
              />
            </div>
          }
          nextArrow={
            <div className="slick-next">
              <HiOutlineArrowNarrowRight
                size={24}
                strokeWidth={2}
                className="tw-text-white hover:tw-text-brand-green"
              />
            </div>
          }
          slidesToShow={3}
          slidesToScroll={3}
          infinite={true}
          responsive={[
            {
              breakpoint: 800,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
              },
            },
            {
              breakpoint: 540,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              },
            },
          ]}
          className="tw--mx-3.75 slider-v2 carousel-collections carousel-collections--static-faqs"
        >
          {FAQs.map((review, index) => (
            <div className="tw-px-3.75" key={index}>
              <div
                className={`tw-p-8 tw-bg-brand-yellow tw-rounded-lg tw-text-center ${reviewStyle.reviewCard}`}
              >
                <div className="tw-text-center tw-leading-none">
                  {[...Array(5)].map((key) => (
                    <BsStarFill
                      key={key}
                      width={20}
                      height={20}
                      className="tw-text-orange tw-align-top tw-mx-1"
                    />
                  ))}
                </div>
                <div className="tw-py-4 tw-font-styleSans tw-font-semibold tw-text-xl tw-leading-none md:tw-leading-none tw-mb-2 md:tw-max-w-xs">
                  {translation(review.titleTranslationKey)}
                </div>
                <div className="tw-mb-4 tw-whitespace-pre-line">
                  {translation(review.bodyTranslationKey)
                    .split('<br/>')
                    .map((line, i) => (
                      <div className="tw-mb-2" key={i}>
                        {line}
                      </div>
                    ))}
                </div>
                <div className="tw-text-sm tw-font-semibold">{review.name}</div>
              </div>
            </div>
          ))}
        </Slider>
        <div className="tw-pb-16"></div>
      </div>
    </div>
  );
};

export default StaticCustomerReviews;
